import { render, staticRenderFns } from "./PageLast.vue?vue&type=template&id=174db16c"
import script from "./PageLast.vue?vue&type=script&lang=js"
export * from "./PageLast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports